import { gql } from '@apollo/client'

export default gql(`
query getAppConfig($id: ID!, $project: String!) {
    getAppConfig(id: $id, project: $project) {
        id
        key
        title
        project
        createdAt
        updatedAt
        updatedBy
        createdBy
    }
}`)
